export default __webpack_public_path__ + "static/media/image-22.b96ce0bc.png";